<style lang="scss" scoped>
  .base-input {
    -webkit-appearance: none;
  }
</style>

<template>
  <input
    v-bind="$attrs"
    class="form-control base-input"
    v-on="listeners"/>
</template>

<script>

export default {
  inheritAttrs: false,
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: event => {
          this.$emit('input', event.target.value)
        },
      }
    },
  },
}
</script>
